import { render } from "./barcode.vue?vue&type=template&id=536b88f7"
import script from "./barcode.vue?vue&type=script&lang=js"
export * from "./barcode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__